module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa277232.woff";